import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import RulesGrid from 'shared/components/rulesGrid/RulesGrid';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import { RULE_PROP_TYPE } from 'shared/constants/PropTypes';

class RulesSelector extends React.PureComponent {
  componentWillMount() {
    this.props.rulesActions.fetchRules(0, 10);
  }

  handleRuleSelect = rule => this.props.rulesActions.updateSelectedRules(rule);

  handlePageChange = (page, perPage) => this.props.rulesActions.fetchRules(page, perPage);

  handleAddSelectedRows = () => this.props.rulesActions.addOrderedRules();

  render() {
    const { rules, totalEntries, fetchingRules, selectedRules, orderedRules } = this.props;
    const selectedRulesCount = selectedRules.length;
    const rulesData = rules.map(rule => {
      const inOrderedRules = orderedRules.findIndex(selectedRule => selectedRule.id === rule.id) >= 0;
      const inSelectedRules = selectedRules.findIndex(selectedRule => selectedRule.id === rule.id) >= 0;
      return ({
        ...rule,
        selected: !fetchingRules && (inSelectedRules || inOrderedRules),
        disabled: inOrderedRules
      });
    });
    return (
      rules.length > 0 &&
      <div className="rules-selector__container" >
        <h2>1. Select Rules</h2>
        <RulesGrid
          rulesListGridData={ rulesData }
          onRuleSelect={ this.handleRuleSelect }
          totalItems={ totalEntries }
          onPageChange={ this.handlePageChange }
          fetchingRules={ fetchingRules }
          showPagination={ true }
          displayCheckbox={ true }
        />
        <SovosButtonsGroup align="right">
          <FlatButton label={ `ADD ${selectedRulesCount} RULES` } disabled={ selectedRulesCount === 0 } onClick={ this.handleAddSelectedRows } />
        </SovosButtonsGroup>
      </div>
    );
  }
}

RulesSelector.propTypes = {
  rules: PropTypes.arrayOf(RULE_PROP_TYPE).isRequired,
  selectedRules: PropTypes.arrayOf(RULE_PROP_TYPE).isRequired,
  orderedRules: PropTypes.arrayOf(RULE_PROP_TYPE).isRequired,
  totalEntries: PropTypes.number.isRequired,
  rulesActions: PropTypes.shape({
    fetchRules: PropTypes.func,
    updateSelectedRules: PropTypes.func,
    addOrderedRules: PropTypes.func
  }).isRequired,
  fetchingRules: PropTypes.bool
};

RulesSelector.defaultProps = {
  fetchingRules: false
};

export default RulesSelector;



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/rulesPanel/comp/profileRulesManagement/comp/rulesSelector/RulesSelector.js